/**
 * The preview iframe is CSS-scaled when zoomed out. The browser paints the
 * native drag image from the element's layout size, so it looks full size
 * on screen. Snapshot a copy at the iframe's scale instead.
 */
export function iframePreviewScale() {
    try {
        const frame = window.frameElement;
        if (!frame) return 1;
        const transform = frame.ownerDocument.defaultView.getComputedStyle(frame).transform;
        if (!transform || transform === 'none') return 1;
        const scale = new DOMMatrixReadOnly(transform).a;
        return scale > 0 ? scale : 1;
    } catch {
        return 1;
    }
}

export function setScaledDragImage(event, source) {
    const transfer = event?.dataTransfer;
    if (!transfer || !source) return;
    const scale = iframePreviewScale();
    if (scale >= 0.98) return;
    const rect = source.getBoundingClientRect();
    if (!(rect.width > 0) || !(rect.height > 0)) return;
    const ghost = source.cloneNode(true);
    ghost.setAttribute('aria-hidden', 'true');
    ghost.style.position = 'fixed';
    ghost.style.left = '-10000px';
    ghost.style.top = '0';
    ghost.style.margin = '0';
    ghost.style.width = `${rect.width}px`;
    ghost.style.height = `${rect.height}px`;
    ghost.style.zoom = String(scale);
    ghost.style.pointerEvents = 'none';
    document.body.appendChild(ghost);
    try {
        transfer.setDragImage(ghost, (rect.width * scale) / 2, Math.min(28, (rect.height * scale) / 2));
    } catch {
        /* setDragImage can throw if the drag already started */
    }
    setTimeout(() => ghost.remove(), 0);
}
